module.exports = __webpack_public_path__ + "img/81.d99a1ba9.svg";